import {EntityField} from "../../core/genericdocuments/EntityField"
import {EntityFieldDataType} from "../../core/genericdocuments/EntityFieldDataType"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails"
import {Tenant} from "../../models/Tenant"

export const tenantFields: IntercateKeysMap<Tenant, EntityField<Tenant>> = {
    id: {
		name: "id", dataType: EntityFieldDataType._string, label: "Id tenant",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    title: {
		name: "title", dataType: EntityFieldDataType._string, label: "Naziv",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    address: {
		name: "address", dataType: EntityFieldDataType._string, label: "Adresa",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    vatId: {
		name: "vatId", dataType: EntityFieldDataType._string, label: "PIB",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    companyId: {
		name: "companyId", dataType: EntityFieldDataType._string, label: "Matični broj",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    accountNumber: {
		name: "accountNumber", dataType: EntityFieldDataType._string, label: "Žiro račun",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    invoiceBackground: {
		name: "invoiceBackground", dataType: EntityFieldDataType._string, label: "Pozadina računa",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    invoiceText: {
		name: "invoiceText", dataType: EntityFieldDataType._string, label: "Opšti tekst na računu",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    invoiceResponsible: {
		name: "invoiceResponsible", dataType: EntityFieldDataType._string, label: "Potpisnik računa",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    uploads: {
        name: "uploads", dataType: EntityFieldDataType._reference, label: "Uploads",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Uploads
		},
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    invoiceHeaderImageId: {
        name: "invoiceHeaderImageId", dataType: EntityFieldDataType._reference, label: "Header",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Tenants
		},
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    invoiceFooterImageId: {
        name: "invoiceFooterImageId", dataType: EntityFieldDataType._reference, label: "Footer",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Tenants
		},
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    invoiceHeaderImage: {
		name: "invoiceHeaderImage", dataType: EntityFieldDataType._string, label: "Header image",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    invoiceFooterImage: {
		name: "invoiceFooterImage", dataType: EntityFieldDataType._string, label: "Footer image",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
}

const tenantFieldsArray: Array<EntityField<Tenant>> = [
	tenantFields.title,
    tenantFields.address,
	tenantFields.vatId,
    tenantFields.companyId,
    tenantFields.accountNumber,
    tenantFields.invoiceText,
	tenantFields.invoiceResponsible,
    tenantFields.invoiceHeaderImageId,
    tenantFields.invoiceFooterImageId,
]

export const tenantFieldsDescriptor: EntityFieldsDescriptor<Tenant> = {
	listFields: tenantFieldsArray,
	createFormFields: tenantFieldsArray,
	updateFormFields: tenantFieldsArray
}